import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=47bb9d60&"
import script from "./Relay.vue?vue&type=script&lang=js&"
export * from "./Relay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/mnt/extradrive/src/pwswim.org/www/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
